import React from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export interface FillEmptyDescriptionsDialogProps {
  open: boolean;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
  emptyDescriptionCount: number;
  bulkDescription: string;
  setBulkDescription: React.Dispatch<React.SetStateAction<string>>;
  onFill: () => void;
}

/** Bulk-applies a single description to every row that has none. */
export function FillEmptyDescriptionsDialog({
  open,
  onOpenChange,
  emptyDescriptionCount,
  bulkDescription,
  setBulkDescription,
  onFill,
}: FillEmptyDescriptionsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Fill Empty Descriptions</DialogTitle>
          <DialogDescription>
            This will update {emptyDescriptionCount} row{emptyDescriptionCount !== 1 ? 's' : ''} with blank descriptions.
            Rows that already have descriptions will not be changed.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Textarea
            value={bulkDescription}
            onChange={(e) => setBulkDescription(e.target.value)}
            placeholder="Enter description for selected rows..."
            className="min-h-[100px]"
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              setBulkDescription('');
            }}
          >
            Cancel
          </Button>
          <Button onClick={onFill}>
            Fill {emptyDescriptionCount} Description{emptyDescriptionCount !== 1 ? 's' : ''}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
